/**
 * @todo Удалить файл с RS
 * @description Данный функционал появился в задаче CD-93942, будет удалён в задаче CD-97910
 */
import { getConfig } from '@cian/config/browser';

let coworkingWorkplacePriceEnabled: null | boolean = null;

export function getCoworkingWorkplacePriceEnabled() {
  if (coworkingWorkplacePriceEnabled === null && window) {
    const config = getConfig();

    coworkingWorkplacePriceEnabled = !!config.get<boolean>('CoworkingWorkplacePrice.Enabled');
  }

  return coworkingWorkplacePriceEnabled;
}
/**
 * @end
 */
